import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import React from "react";
import { ChevronProps } from "react-day-picker";

/**
 * Replacement Chevron component compatible with react-day-picker.
 */
export function DayPickerChevron({ orientation }: ChevronProps) {
  return orientation === "left" ?
      <ChevronLeftIcon boxSize={6} />
    : <ChevronRightIcon boxSize={6} />;
}
